import React, { useState, useEffect } from "react";

const CategoryTableLimits = ({
  trackCategory,
  filterInputCategory,
  setFilterInputCategory,
  setCategoryOptionSelected,
  categoryOptionSelected,
  setCategoryName,
  setBetTypeOptionSelected,
  setBetTypeName,
}) => {
  const [filteredData, setFilteredData] = useState([]);

  //This useEffect filters the Tracks table according to Book Description.
  useEffect(() => {
    let filteredData = trackCategory;
    //Books input filter
    if (filterInputCategory) {
      filteredData = filteredData.filter((item) =>
        item.Description.toLowerCase().includes(
          filterInputCategory.toLowerCase(),
        ),
      );
    }
    setFilteredData(filteredData);
  }, [trackCategory, filterInputCategory]);

  // Headers
  let headers,
    categoriesTable = [];
  headers = (
    <tr className="text-center">
      <th hidden>IDCategory</th>
      <th>Category</th>
    </tr>
  );

  // This constant is used internally to set the selected Track Name or Track Code in the filters
  const handleInputFilterChange = (event) => {
    setFilterInputCategory(event.target.value);
  };

  // The main Categories table
  if (trackCategory) {
    categoriesTable = filteredData.map((item, i) => {
      return (
        <React.Fragment key={i}>
          <tr
            key={item.IDTrackCategory}
            onClick={() =>
              handleCategoryChange(item.IDTrackCategory, item.Description)
            }
            className={
              categoryOptionSelected === item.IDTrackCategory ? "shadedRow" : ""
            }
            style={{ cursor: "pointer" }}
          >
            <td key={"IDTrackCategory" + i} className="d-none">
              {item.IDTrackCategory}
            </td>
            {/* Profile Name */}
            <td
              key={"Description" + i}
              style={{
                verticalAlign: "middle",
                textAlign: "center",
                whiteSpace: "normal",
                fontSize: "14px",
              }}
            >
              {item.Description}
            </td>
          </tr>
        </React.Fragment>
      );
    });
  }

  // This function displays the Limit associated with each book
  const handleCategoryChange = (idCategory, categoryName) => {
    setCategoryOptionSelected(idCategory);
    setCategoryName(categoryName);
    setBetTypeOptionSelected(0);
    setBetTypeName("Win");
  };

  return (
    <div>
      <div style={{ textAlign: "center" }}>
        <p
          className="lead"
          style={{ color: "#8c8c8c", fontSize: "16px", cursor: "default" }}
        >
          Category List
        </p>
      </div>
      <div style={{ textAlign: "center" }}>
        <input
          value={filterInputCategory}
          onChange={handleInputFilterChange}
          placeholder={"Category Search..."}
          className="form-control mb-1"
        />
      </div>
      <div
        className="tablesLimits"
        style={{
          overflow: "auto",
        }}
      >
        <table className="table table-hover table-sm mt-2">
          <thead
            style={{ position: "sticky", top: "0", background: "#d9d9d9" }}
          >
            {headers}
          </thead>
          <tbody className="table-lg">{categoriesTable}</tbody>
        </table>
      </div>
    </div>
  );
};

export default CategoryTableLimits;
